import styled from 'styled-components';
const SearchGroupStyled = styled.div`
  border-radius: 12px;
  /* margin-bottom: 24px; */
  .search-wrapper {
    padding: 24px 24px;
    box-shadow: 0 0 5px 0 rgba(181, 181, 181, 0.26);
    border-radius: 12px;
    background: #ffffff;
    display: flex;
  }
  .left {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }
  .css-1q60rmi-MuiAutocomplete-endAdornment {
    display: flex;
    .MuiIconButton-root {
      width: 16px;
      height: 16px;
    }
    .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    }
  }
  .button-group {
    height: 100%;
    margin-left: 64px;
    display: flex;
    /* flex-direction: column; */
    /* justify-content: space-between;
    align-items: center; */
    .reset {
      /* margin-bottom: 24px; */
      margin-right: 24px;
    }
    .search {
      margin-right: 0;
    }
  }
  .first-line {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    gap: 48px;
    > div {
      /* width: 25%; */
      flex: 1;
      /* margin-right: 48px; */
    }
  }

  .single-select {
    /* width: 400px; */
    /* height: 56px; */
  }

  .MuiTextField-root {
    /* width: 400px; */
    /* height: 56px; */
  }
`;
export default SearchGroupStyled;
